import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';
import {TFunction} from 'react-i18next';

export const renderActionButtons = (onRemove: () => void, translation: TFunction<'translation'>, confirmed?: boolean, onConfirm?: () => void): JSX.Element => {
    let withConfirmation = false;
    if (onConfirm) {
        withConfirmation = true;
    }

    return <div
        className={'submit-action'}>
        {withConfirmation && <SvgIcon
            className="confirm-icon"
            icon={confirmed ? Icons.CONFIRMED : Icons.CONFIRM}
            onClick={onConfirm}
            alt={translation('search.details.confirm')}
        />}
        < SvgIcon
            className="delete-icon"
            icon={Icons.REMOVE}
            onClick={onRemove}
            alt={translation('search.details.remove')}
        />
    </div>;
};

